import React, { useCallback, useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { Navigate, useLocation } from "react-router-dom";
import { http } from "middleware/apiMiddleware";
import GoBack from "components/Common/GoBack";
import { getBaseUrl } from "utils/common";
import useMixpanel from "hooks/useMixpanel";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY || "");

interface IPurchaseFormProps {
  config?: StripeConfig;
}
const Purchase: React.FC<IPurchaseFormProps> = ({}) => {
  const location = useLocation();
  const config = location?.state;
  const { trackEvent } = useMixpanel();

  const getStripeUrl = () =>
    `${getBaseUrl()}/transactionStatus?businessId=${
      config?.businessId
    }&planId=${config?.moduleId}`;

  const fetchClientSecret = useCallback(async () => {
    try {
      // Create a Checkout Session
      const { data, error } = await http.patch(
        `/business/${config?.businessId}/business-paid-modules/${config?.moduleId}`,
        {
          enabled: true,
          returnUrl: getStripeUrl(),
          formData: { autoTopUpAmount: config?.topUpAmount },
        }
      );

      if (!!data && !error) return data?.sessionTokens?.clientSecret;
      trackEvent("activate_offer_success", {
        planId: config?.planid,
        topUpAmount: config?.topUpAmount,
      });
    } catch (error) {
      trackEvent("activate_offer_failure", {
        planId: config?.planid,
        topUpAmount: config?.topUpAmount,
      });
      console.error("error activating stripe module");
    }
  }, []);

  const options = { fetchClientSecret };

  return (
    <div
      id="checkout"
      className="bg-white p-4 mx-auto  h-full flex-col flex gap-8"
    >
      <GoBack label={<>Go Back</>} />
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

const Return = () => {
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState("");

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");

    fetch(`/session-status?session_id=${sessionId}`)
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.status);
        setCustomerEmail(data.customer_email);
      });
  }, []);

  if (status === "open") {
    return <Navigate to="/checkout" />;
  }

  if (status === "complete") {
    return (
      <section id="success">
        <p>
          We appreciate your business! A confirmation email will be sent to{" "}
          {customerEmail}. If you have any questions, please email{" "}
          <a href="mailto:orders@example.com">orders@example.com</a>.
        </p>
      </section>
    );
  }

  return null;
};

export default Purchase;
